import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { formatTime, toDateTime } from '@shared/utils/date-time';
import { DateTime } from 'luxon';

@Pipe({ name: 'appTime' })
export class AppTimePipe implements PipeTransform {
    transform(value: string | DateTime | Date, toLocal = true): any {
        if (!value) {
            return;
        }

        let instance = toDateTime(value);

        if (!instance.isValid && typeof value === 'string') {
            try {
                instance = toLocal
                    ? DateTime.fromFormat(value, 'HH:mm').toLocal()
                    : DateTime.fromFormat(value, 'HH:mm');
            } catch (error) {
                console.error(error);
            }
        }

        if (instance instanceof DateTime && instance.isValid) {
            return formatTime(instance, toLocal);
        }

        return value;
    }
}
